import React, { useState } from 'react';
import { Container, Row, Form } from 'react-bootstrap';
import * as yup from 'yup';
import { useAppDispatch, useTypedSelector } from 'store/store';
import { useHistory } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { yupResolver } from '@hookform/resolvers/yup';
import TextField from 'components/Atoms/TextField';
import { LoadingButton } from '@mui/lab';
import { Auth } from 'aws-amplify';
import { triggerUxCritialErrors } from 'actions/error';
import storage from 'helpers/storage';
import { authActions } from 'pages/login/auth.slice';
import { passwordRegex } from 'helpers/constants';

const newPasswordSchema = yup.object().shape({
  newPassword: yup.string()
    .matches(passwordRegex, "Your password does not follow the standards")
    .min(8, "Password should be minimum 8 characters.")
    .required("New Password is required."),
  confirmPassword: yup.string()
    .required('Confirm Password is required.')
    .oneOf([yup.ref('newPassword'), null], "New Password and Confirm Password should be same")
})

function NewPasswordSetup() {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const auth = useTypedSelector(state => state.auth);
  const cognitoUser = auth.cognitoUser;

  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false);

  const { handleSubmit, formState: { errors }, control } = useForm({ resolver: yupResolver(newPasswordSchema) });

  const handleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  }

  const handleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  }

  const onSubmit = (data) => {
    setIsLoading(true);

    console.log('data ==> ', data);
    const { newPassword } = data;
    Auth.completeNewPassword(cognitoUser, newPassword).then(user => {
      console.log('auth new password: ', user);

      Auth.userSession(user).then(session => {
        const idToken = session.getIdToken().getJwtToken();
        const tokensPayload = { access: idToken };
        const _user = session.getIdToken().payload.user_details;
        const user = JSON.parse(_user);

        storage.set("authToken", idToken, "local");
        storage.set("showReleaseNotes", true, "local");
        storage.set("authFailed", false, "local");

        dispatch({
          payload: {
            authorizationDone: true,
          },
          type: "AUTHORIZATION_DONE",
        });

        dispatch({
          payload: {
            userDetails: user
          },
          type: "USER_DETAILS_FETCHED",
        });

        dispatch(authActions.actions.setTokens(tokensPayload));
        dispatch(authActions.actions.setUser(user));

        setIsLoading(false);

        history.replace('/');
      });
    }).catch(err => {
      setIsLoading(false);
      triggerUxCritialErrors(err, dispatch);
    });
  }

  console.log('cognito user: ', cognitoUser);

  return (
    <Container fluid className="login_container">
      <Row className="login_title">
        <span>Change your password to a new one</span>
      </Row>
      <Row className="login_box">
        <span>New Password</span>
        <div>
          <Form
            className="login_form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="returning_customer_container">
              <div className="input_fields">
                <list>Password should contain -
                  <ul>
                    <li>Minimum password length – 8.</li>
                    <li>Password should contain atleast 1 uppercase, 1 lowercase, 1 number and a special character.</li>
                    <li>{`Special character should include - = + - ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ \``}</li>
                  </ul>
                </list>
                <Controller name="newPassword" control={control} render={({ field }) => <TextField
                  {...field}
                  error={Boolean(errors.newPassword)}
                  helperText={errors.newPassword?.message}
                  fullWidth
                  placeholder="Enter New Password"
                  label="New Password"
                  type={showNewPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleShowNewPassword}
                        >
                          {showNewPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />} />
                <Controller name="confirmPassword" control={control} render={({ field }) => <TextField
                  {...field}
                  error={Boolean(errors.confirmPassword)}
                  helperText={errors.confirmPassword?.message}
                  fullWidth
                  placeholder="Enter Confirm Password"
                  label="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleShowConfirmPassword}
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />} />
              </div>
              <LoadingButton
                type="submit"
                sx={{ py: 1.5 }}
                loading={isLoading}
                loadingPosition="start"
                variant="contained"
                fullWidth
                size="large"
              >
                {`${isLoading ? "Loading..." : "Change Password"}`}
              </LoadingButton>
            </div>
          </Form>
        </div>
      </Row>
    </Container>
  );
}
export default NewPasswordSetup;
